import { useTranslations } from "use-intl";

import { CollapsibleCard } from "@/features/trips/components/CollapsibleCard";
import { formatCurrency } from "@/utils/currency";

type Props = {
  basePrice: number;
  baseDiscount: number;
  tourPrice?: number;
  promoCodeDiscount?: number;
  totalPrice: number;
};

export function PriceDetailsCard({
  basePrice,
  baseDiscount,
  promoCodeDiscount,
  tourPrice,
  totalPrice,
}: Props) {
  const t = useTranslations();

  return (
    <CollapsibleCard title={t("trips.priceDetails.title")} collapsible={false}>
      <dl className="grid grid-cols-2 gap-2 text-sm">
        <dt className="text-text-disabled-primary">{t("trips.basePrice")}</dt>
        <dd className="text-end font-bold">{formatCurrency(basePrice)}</dd>

        {tourPrice !== undefined && (
          <>
            <dt className="text-text-disabled-primary">
              {t("trips.tours.tourPrice")}
            </dt>
            <dd className="text-end font-bold">{formatCurrency(tourPrice)}</dd>
          </>
        )}

        <dt className="text-text-disabled-primary">{t("trips.discount")}</dt>
        <dd className="text-end font-bold">{formatCurrency(baseDiscount)}</dd>

        {promoCodeDiscount ? (
          <>
            <dt className="text-text-disabled-primary">
              {t("promoCode.promoCodeDiscount")}
            </dt>
            <dd className="text-end font-bold text-core-accent-500">
              {formatCurrency(promoCodeDiscount)}
            </dd>
          </>
        ) : null}

        <dt className="text-text-disabled-primary">{t("paymentMethod")}</dt>
        <dd className="text-end font-bold">{t("qiCard")}</dd>

        <dt className="text-text-disabled-primary">{t("trips.totalPrice")}</dt>
        <dd className="text-end font-bold">{formatCurrency(totalPrice)}</dd>
      </dl>
    </CollapsibleCard>
  );
}
